var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBtnClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Union 11",
    d: "M.501 12.5a12 12 0 1112 12 12 12 0 01-12-12zm1.5 0A10.5 10.5 0 1012.501 2a10.5 10.5 0 00-10.5 10.5zm14.469 5.031l-3.969-3.971-3.969 3.971a.751.751 0 01-1.062-1.062l3.97-3.969-3.97-3.969a.748.748 0 010-1.06h0a.75.75 0 011.06 0h0l3.971 3.969 3.969-3.971a.751.751 0 011.062 1.062L13.561 12.5l3.971 3.969a.751.751 0 11-1.062 1.062z",
    fill: "#fff",
    stroke: "rgba(0,0,0,0)"
  })));
}
export default SvgBtnClose;